import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { usePatientByIdQuery } from "@/modules/patients/services/usePatientByIdQuery"
import { Country, HealthInformationType } from "@/types/__generated__/union-types"

const useGetHealthInformationVerification = (
  patientId: string,
  countryCode: Country,
  healthInformationType: HealthInformationType,
) => {
  const appointmentId = useAppointmentParam()
  const [patientData] = usePatientByIdQuery(patientId, countryCode, appointmentId)
  const lastVerification = patientData?.patientById?.healthInformationLastVerification.find(
    (v) => v.patientId === patientId && v.healthInformationType === healthInformationType,
  )
  const verifiedBy = lastVerification?.verifiedBy
  const verifiedAt = lastVerification?.verifiedAt
  const verification = patientData?.patientById?.healthInformationVerifications
  const isVerified = !!verification?.find(
    (v) => v.patientId === patientId && v.healthInformationType === healthInformationType,
  )?.verifiedAt

  return { verifiedBy, verifiedAt, isVerified }
}

export { useGetHealthInformationVerification }
